import { ApiV3 } from '../../commonv3/api/ApiV3';
import { MainV3ApiBase } from './base';

export const MokumokuStudyRoomEntriesApis = {
  base(): ApiV3 {
    return MainV3ApiBase.appendPath('users/current/mokumoku_study_room_entries');
  },
  async create(): Promise<void> {
    return await this.base().post();
  },
};
